import { render, staticRenderFns } from "./WhatisDid.vue?vue&type=template&id=c09652f4&scoped=true&"
import script from "./WhatisDid.vue?vue&type=script&lang=js&"
export * from "./WhatisDid.vue?vue&type=script&lang=js&"
import style0 from "./WhatisDid.vue?vue&type=style&index=0&id=c09652f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09652f4",
  null
  
)

export default component.exports